export enum RateChoiceEnum {
  BY_ORDER = 'BY_ORDER',
  PRICE = 'PRICE',
}
